module.exports = __webpack_public_path__ + "19156af93053612a8cb1b72f2e736111.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/LeagueGothic/leaguegothic-regular-webfont.ttf
// module id = 354
// module chunks = 0